<template>
  <el-table
    :data="playbooks"
    style="width: 100%">
        <el-table-column
            width="70"
            label="Playbook ID"
            prop="id"
            sortable="true"
            >
        </el-table-column>
        <el-table-column 
        >
            {{getName()}}
        </el-table-column>
        <el-table-column 
            label="Repeat goal"
            prop="goal"
        >
        </el-table-column>
        <el-table-column 
            label="Time"
            prop="time_of_days"
        >
        </el-table-column>
  </el-table>
</template>

<script>

export default {
    name: 'PlaybooksList',
    components: {
        
    },
    props: {
        playbooks: {
            type: Object,
            default: () => {}
        },
        botName: {
            type: String,
            default: () => "unknown"
        },
    },
    data () {
        return {
        
        }
    },
    methods: {
      getName() {
          return this.botName;
      }
    }
}
</script>

<style lang="scss" scoped>

</style>
